"use client";

import React from "react";
import { 
  Box, 
  Flex, 
  Heading, 
  Text, 
  Button, 
  Badge, 
  Image, 
  HStack, 
  VStack,
  IconButton
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import { ClientData } from "./types";

interface ClientHeaderProps {
  client: ClientData;
  onClose: () => void;
}

const ClientHeader: React.FC<ClientHeaderProps> = ({ client, onClose }) => {
  return (
    <Box as="header" overflow="hidden" px="1px" bg="gray.100" w="full" position="relative">
      <Flex flexDir="column" justifyContent="center" w="full">
        <Flex wrap="wrap" gap="10" justifyContent="space-between" alignItems="center" w="full" py={4} px={6}>
          <Flex gap="2" alignItems="center" minW="240px">
            <Image
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/d91706ac1d6e14463933b5d208c40ae34235e350?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9"
              objectFit="contain"
              flexShrink={0}
              alignSelf="center"
              w="90px"
              h="90px"
              alt="Client profile"
            />
            <VStack alignItems="flex-start" spacing={2} justifyContent="center" minW="240px">
              <HStack>
                <Heading alignSelf="stretch" fontSize="2xl" color="blue.900">
                  {client.name}
                </Heading>
                <Badge 
                  alignSelf="stretch" 
                  px="2" 
                  py="1"
                  fontSize="xs" 
                  color="green.500" 
                  borderRadius="sm" 
                  bg="green.50"
                >
                  {client.isActive ? "Active" : "Inactive"}
                </Badge>
              </HStack>
              <HStack fontSize="xs" color="gray.500" spacing={2}>
                {/* <Flex gap="1" alignItems="center" px="2" py="1" borderRadius="sm">
                  <Box flexShrink={0} w="5" h="5" />
                  <Text>Rep:</Text>
                  <Text>{client.representative}</Text>
                </Flex> */}
                {client.pendingStatuses.map((status, index) => (
                  <Flex 
                    key={index} 
                    gap="1" 
                    justifyContent="center" 
                    alignItems="center" 
                    px="2" 
                    py="1" 
                    borderRadius="sm"
                  >
                    <Image
                      src={`https://cdn.builder.io/api/v1/image/assets/TEMP/placeholder${index + 2}?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9`}
                      objectFit="contain"
                      flexShrink={0}
                      alignSelf="center"
                      w="3"
                      h="3"
                      alt="Status icon"
                    />
                    <Text>{status}</Text>
                  </Flex>
                ))}
              </HStack>
            </VStack>
          </Flex>
          
          <HStack spacing={1} fontSize="xs" color="white">
            {/* <Image
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/2ce2a28b49c4a4f23f13495bdf02b0033bd91c85?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9"
              objectFit="contain"
              flexShrink={0}
              alignSelf="center"
              w="5"
              h="5"
              alt="Channel icon"
            />
            <Button 
              overflow="hidden"
              px="4" 
              py="2" 
              bg="purple.700" 
              borderRadius="md" 
              height="auto"
              fontSize="xs"
              color="white"
            >
              Channel Partner
            </Button> */}
            <IconButton
              aria-label="Close"
              icon={<Image
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/82ae17edeaa925b21e8e32fc9e23ac0045edfb9c?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9"
                objectFit="contain"
                w="19px"
                h="19px"
                alt="Close"
              />}
              size="sm"
              variant="unstyled"
              minW="auto"
              height="auto"
              onClick={onClose}
              _hover={{ opacity: 0.8 }}
            />
          </HStack>
        </Flex>
      </Flex>
    </Box>
  );
};

export default ClientHeader; 